import React, { useEffect, useState, Suspense, lazy } from 'react';
import PropTypes from 'prop-types';
import { Transition } from 'react-transition-group';
import { ToastContainer, toast } from 'react-toastify';
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props';
import AOS from 'aos';
import 'aos/dist/aos.css';
// import UserModel from '../../models/user';

import '../../styles/Components/onboarding.scss';
import DefaultButton from '../Input/DefaultButton';
import InputForm from './InputForm';
import cuid from 'cuid';
import {
  getNonInstaParams,
} from '../../utils/helpers';
import AsyncArray from '../../utils/AsyncArray';
import { setCurrentCompanyId, setCurrentServiceId } from '../../models/firebase';
const Checkbox = lazy(() => import('react-simple-checkbox'));
const redirectUri = process.env.NODE_ENV === 'development' ? 'https://localhost:8000/portal/' : process.env.GATSBY_API_URL === 'https://api-staging.reachsocialgrowth.com' ? 'https://reachsocialgrowth-staging.netlify.app/portal/' : 'https://reachsocialgrowth.com/portal/';

const Onboarding = ({
  onCompletion,
  hasBeenInvited,
  model,
}) => {
  const duration =500;

  const defaultStyle = {
    transform: 'translateY(100vw)',
    position: 'absolute',
    transition: `all ${duration}ms cubic-bezier(0.645, 0.045, 0.355, 1)`,
  }

  const transitionStyles = {
    entering: { transform: 'translateY(100vw)', display: 'block' },
    entered:  { transform: 'translateY(300px)', display: 'block'  },
    exiting:  { transform: 'translateY(-100vw)', display: 'block' },
    exited:  { transform: 'translateY(100vw)', display: 'none' },
  };
  const [isLoading, setIsLoading] = useState(false);
  const [values, setValues] = useState({
    firstName: {
      value: '',
      valid: new RegExp(/.+/g),
      isValid: false,
    },
    lastName: {
      value: '',
      valid: new RegExp(/.+/g),
      isValid: false,
    },
    industry: {
      value: '',
      valid: new RegExp(/.+/g),
      isValid: true,
    },
    companyName: {
      value: '',
      valid: new RegExp(/.+/g),
      isValid: false,
    },
  });
  const [step, setStep] = useState(0);
  const [pages, setPages] = useState([]);
  const [fbResponse, setFBResponse] = useState(undefined)
  const [currentService, setCurrentService] = useState(undefined);
  const [selectedAccounts, setSelectedAccounts] = useState([]);
  if (typeof AOS.init === 'function') {
    AOS.init({
      once: true,
    });
  }
  useEffect(() => {
    if (step === 2) {
      // check if user already has a company
    }
  }, [step])
  const updateValues = (id, value) => {
    setValues(prevState => ({
      ...prevState,
      [id]: {
        value: value,
        valid: prevState[id].valid,
        isValid: prevState[id].valid.test(value),
      }
    }))
  }
  const createUserAndCompany = async () => {
    setStep(step + 1);
  }
  const save = () => {
    onCompletion(values);
  }
  
  const step1Valid = values.firstName.isValid
    && values.lastName.isValid;
  const step2Valid = values.companyName.isValid;

  const responseFacebook = async (response) => {
    setIsLoading(true);
    try {
      const createCompanyResponse = await model.createCompany(values.companyName.value, values.industry.value)
      await setCurrentCompanyId(createCompanyResponse.id, model);
      if (createCompanyResponse.invalid) {
        toast.error(createCompanyResponse.message, {
          position: toast.POSITION.TOP_LEFT
        });
      }
      setFBResponse(response);
      const pageData = await model.getFacebookPages(response.accessToken);
      const asyncArray = new AsyncArray(pageData.data);
      const instaPages = await asyncArray.filterAsync(async (account) => {
        return new Promise(async res => {
          const instagramBusinessId = await model.getPageInstagramAccount(account.id, account.access_token);
          res(instagramBusinessId.instagram_business_account !== undefined);
        });
      })
      setIsLoading(false);
      if (instaPages.length === 0) {
        toast.error("Sorry. There was no valid instagram business account selected. Please try loggin in again and going to Edit Settings and select your business facebook page and instagram account.", {
          position: toast.POSITION.TOP_LEFT
        });
      } else {
        setPages(instaPages)
        setStep(step + 1);
      }
    } catch (err) {
      console.log(err);
      setIsLoading(false);
      toast.error(`${err} - There was an error setting up your account. Please try again.`, {
        position: toast.POSITION.TOP_LEFT
      });
    }
    
  };
  async function asyncForEach(array, callback) {
    for (let index = 0; index < array.length; index++) {
      await callback(array[index], index, array);
    }
  }
  const generateServices = async () => {
    setIsLoading(true);
    let count = 0;
    let error = false;
    
    asyncForEach(selectedAccounts, async (account) => {
      const instagramBusinessId = await model.getPageInstagramAccount(account.id, account.access_token);
      const businessId = instagramBusinessId.instagram_business_account.id;
      const serviceData = {
        fb_access_token: fbResponse.accessToken,
        fb_expires_in: new Date().getTime() + fbResponse.expiresIn,
        fb_user_id: fbResponse.userID,
        instagram_id: businessId,
        fb_name: fbResponse.name,
        fb_long_lived_token: account.access_token,
        fb_page_id: account.id,
        service_name: account.name,
      }
      
      const serviceResponse = await model.createService(serviceData);
      if (serviceResponse.invalid) {
        error = true;
        toast.error(serviceResponse.message, {
          position: toast.POSITION.TOP_LEFT
        });
      } else {
        const serviceId = serviceResponse.data.id;
        if (count === 0) {
          await setCurrentServiceId(serviceId, model);
        }
        await model.subscribeToApp(serviceId);
      }
      count += 1
      if (!error && count === selectedAccounts.length) {
        setStep(step + 1);
        setIsLoading(false);
      }
    });
    
  }
  const updateSelectedAccounts = (page) => {
    const alreadySelected = selectedAccounts.filter((account) => account.name === page.name).length > 0;
    if (alreadySelected) {
      setSelectedAccounts(selectedAccounts.filter(account => account.name !== page.name));
    } else {
      setSelectedAccounts(accounts => [...accounts, page]);
    }
  }
  const completedFirstStep = () => {
    if (hasBeenInvited) {
      onCompletion(values);
    } else {
      setStep(step + 1);
    }
  }
  return (
    <div className="onboarding__container">
      {step === 0 && (
        <div className="onboarding__step onboarding__step1" data-aos="fade-in" data-aos-duration="800" data-aos-delay="1500" >
          <h1>Welcome To Reach.</h1>
          <p>We just need to ask a few questions to get started.</p>
          <DefaultButton
            text="Get Started"
            callback={() => setStep(step + 1)}
          />
        </div>
      )}
      <Transition
        in={step === 1}
        mountOnEnter={true}
        timeout={500}
        duration={duration}
      >
        {state => (
        <div style={{
          ...defaultStyle,
          ...transitionStyles[state]
        }}>
          <div className={`onboarding__step onboarding__step2`}>
            <h1>Please enter your name.</h1>
            <InputForm
              placeholder="First Name"
              title="First Name"
              value={values.firstName.value}
              onChange={updateValues}
              id="firstName"
            />
            <InputForm
              placeholder="Last Name"
              title="Last Name"
              value={values.lastName.value}
              onChange={updateValues}
              id="lastName"
            />
            <DefaultButton
              text="Next"
              callback={() => completedFirstStep()}
              disabled={!step1Valid}
            />
          </div>
        </div>
        )}
      </Transition>
      <Transition
        in={step === 2}
        mountOnEnter={true}
        timeout={500}
        duration={duration}
      >
        {state => (
        <div style={{
          ...defaultStyle,
          ...transitionStyles[state]
        }}>
          <div className={`onboarding__step onboarding__step2`}>
            <h1>Enter Company Info.</h1>
            <InputForm
              placeholder="Company Name"
              title="Company Name"
              value={values.companyName.value}
              onChange={updateValues}
              id="companyName"
            />
            <InputForm
              placeholder="Industry (Optional)"
              title="Industry (Optional)"
              value={values.industry.value}
              onChange={updateValues}
              id="industry"
            />
            <div className="row centered">
              <button onClick={() => setStep(step - 1)}>Go Back</button>
              <DefaultButton
                text="Next"
                disabled={!step2Valid}
                callback={() => createUserAndCompany()}
              />
            </div>
          </div>
        </div>
        )}
      </Transition>
      <Transition
        in={step === 3}
        mountOnEnter={true}
        timeout={500}
        duration={duration}
      >
        {state => (
        <div style={{
          ...defaultStyle,
          ...transitionStyles[state]
        }}>
          <div className={`onboarding__step onboarding__step2`}>
            <h1>Sign into your social account.</h1>
            <p>To log into Instagram log in through Facebook and select your page and accounts associated.</p>
            <div className="row centered">
              <button onClick={() => setStep(step - 1)}>Go Back</button>
              <FacebookLogin
                appId="338067493780677"
                fields="name,email,picture"
                scope="instagram_basic,pages_show_list,public_profile,instagram_manage_insights,instagram_manage_comments,manage_pages,pages_manage_metadata"
                autoLoad={false}
                redirectUri={redirectUri}
                callback={responseFacebook}
                disableMobileRedirect
                render={renderProps => (
                  !isLoading ? <DefaultButton
                    text="Log Into Facebook"
                    callback={renderProps.onClick}
                    loading={isLoading}
                  /> : <></>
                )}
              />
            </div>
          </div>
        </div>
        )}
      </Transition>
      <Transition
        in={step === 4}
        mountOnEnter={true}
        timeout={500}
        duration={duration}
      >
        {state => (
        <div style={{
          ...defaultStyle,
          ...transitionStyles[state]
        }}>
          <div className={`onboarding__step onboarding__step2`}>
            <h1>Select Which Accounts You Want to Connect.</h1>
            <div className="row centered">
              {pages.map((page) => (
                <div key={cuid.slug()} className="social-account-block">
                  <Suspense fallback={<div>Loading...</div>}>
                    <Checkbox
                      id={page.name}
                      color="#ED6464"
                      tickSize={1}
                      size={3}
                      borderThickness={1}
                      checked={selectedAccounts.filter((account) => account.name === page.name).length > 0}
                      onChange={() => updateSelectedAccounts(page)}
                    />
                  </Suspense>
                  <label htmlFor={page.name}>{page.name}</label>
                  {/* <div className={`${selectedAccounts.filter((account) => account.name === page.name).length > 0 ? 'selected' : 'unselected'} checkbox`} /> */}
                </div>
              ))}
            </div>
            <DefaultButton
              text="Next"
              disabled={selectedAccounts.length === 0}
              callback={() => generateServices()}
              loading={isLoading}
            />
          </div>
        </div>
        )}
      </Transition>
      <Transition
        in={step === 5}
        mountOnEnter={true}
        timeout={500}
        duration={duration}
      >
        {state => (
        <div style={{
          ...defaultStyle,
          ...transitionStyles[state]
        }}>
          <div className={`onboarding__step onboarding__step2`}>
            <h1>You're all set up!</h1>
            <p>Continue to the dashboard!</p>
            <DefaultButton
              text="Finish"
              callback={() => save()}
            />
          </div>
        </div>
        )}
      </Transition>
      <ToastContainer position={toast.POSITION.TOP_RIGHT} />
    </div>
  )
}

Onboarding.propTypes = {
  onCompletion: PropTypes.func.isRequired,
  hasBeenInvited: PropTypes.bool,
};

Onboarding.defaultProps = {
  hasBeenInvited: false,
};

export default Onboarding;
